import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/PelletsCheckoutDataProvider";
import { DataContext as CalculatorContext } from "../../../../../providers/PelletsDataProvider";
import Headline from "../../../../shared/NewHeadline";
import OrderChoiceButtons from "../../../../shared/OrderChoiceButtons";

const StepPaymentType = () => {
    const dataContext = useContext(DataContext);
    const calculatorContext = useContext(CalculatorContext);
    const { paymentType } = dataContext.data;
    const { setPaymentType, paymentTypeHasChanged } = dataContext.actions;
    const { additions } = calculatorContext.data;

    /**
     * Check if the payment types have some additions.
     */
    const hasAdditions = () => {
        return (
            Object.keys(additions.payment_types).filter((key) => {
                return parseFloat(additions.payment_types[key].add) > 0;
            }).length > 0
        );
    };

    /**
     * When the payment type changes.
     *
     * @param {*} value
     */
    const onChange = (value) => {
        setPaymentType(value);
        paymentTypeHasChanged();
    };

    const getPaymentTypes = () => {
        return Object.keys(additions.payment_types).map((key) => {
            return additions.payment_types[key];
        });
    };

    return (
        <section>
            <Headline>Zahlart</Headline>
            {additions && (
                <OrderChoiceButtons
                    choices={getPaymentTypes()}
                    activeId={paymentType}
                    onChoiceChange={onChange}
                    hasSubtitle={hasAdditions()}
                />
            )}
        </section>
    );
};

export default StepPaymentType;
